<template>
  <Skeleton width="calc(100% - 4rem)" height="2.5rem"></Skeleton>
  <div class="custom-skeleton p-p-4">
    <ul class="p-m-0 p-p-0">
      <li v-for="i in 8" :key="i" class="p-mb-5">
        <div class="p-d-flex">
          <Skeleton size="3rem" class="p-mr-2"></Skeleton>
          <div style="flex: 1">
            <Skeleton width="100%" class="p-mb-2"></Skeleton>
            <Skeleton width="75%"></Skeleton>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
